import { ethers } from 'ethers'

export const splitExists = async ({
  payoutAddress,
  provider
}: {
  payoutAddress: string
  provider: ethers.providers.Provider
}) => {
  const code = await provider.getCode(payoutAddress)
  const exists = code !== '0x'

  return exists
}
